import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';
import { SideCart } from '../SideCart/SideCart';

@Component
export class CartSummary extends ThemeComponent {

    @Ref({ required: false }) continueShoppingButton!: HTMLButtonElement;

    init() {

        // Listen for continue shopping click
        this.listenForContinueShoppingClick();
    }

    listenForContinueShoppingClick() {
        if (this.continueShoppingButton == null) {
            return;
        }
        this.$listen(this.continueShoppingButton, 'click', () => {

            // Attempt to find side cart
            const sideCart = this.closest('.side-cart');
            if (sideCart) {
                const sideCartComponent = sideCart as SideCart;
            }
        });
    }
}
